/* function slideUpFn
**************************************************************/
let slideUpFn = (target, duration = 500) => {
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.boxSizing = "border-box";
	target.style.height = target.offsetHeight + "px";
	target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = "none";
		target.style.removeProperty("height");
		target.style.removeProperty("padding-top");
		target.style.removeProperty("padding-bottom");
		target.style.removeProperty("margin-top");
		target.style.removeProperty("margin-bottom");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
};

/* function slideDownFn
**************************************************************/
let slideDownFn = (target, useDisplay = "block", duration = 500) => {
	target.style.removeProperty("display");
	let display = window.getComputedStyle(target).display;
	display = useDisplay === "" ? "block" : useDisplay;

	if (display === "none") display = useDisplay;

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = "border-box";
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.height = height + "px";
	target.style.removeProperty("padding-top");
	target.style.removeProperty("padding-bottom");
	target.style.removeProperty("margin-top");
	target.style.removeProperty("margin-bottom");
	window.setTimeout(() => {
		target.style.removeProperty("height");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
};

/* function slideToggleFn
**************************************************************/
var slideToggleFn = (target, duration = 500) => {
	if (window.getComputedStyle(target).display === "none") {
		return slideDownFn(target, duration);
	} else {
		return slideUpFn(target, duration);
	}
};

/* is Mobile Device
**************************************************************/
function isMobDevice() {
	let w =
		window.innerWidth ||
		document.documentElement.clientWidth ||
		document.body.clientWidth;

	return Boolean(w < 992);
}

export {
	slideUpFn,
	slideDownFn,
	slideToggleFn,
	isMobDevice,
}



// WEBPACK FOOTER //
// ./scripts/modules/helpers.js